__turbopack_context__.v({
  "aboutMe": "XsuKuW_aboutMe",
  "aboutMeWrapper": "XsuKuW_aboutMeWrapper",
  "address": "XsuKuW_address",
  "agentName": "XsuKuW_agentName",
  "black": "XsuKuW_black",
  "blackText": "XsuKuW_blackText",
  "callMe": "XsuKuW_callMe",
  "callMeWrapper": "XsuKuW_callMeWrapper",
  "card": "XsuKuW_card",
  "cardContainer": "XsuKuW_cardContainer",
  "cards": "XsuKuW_cards",
  "checkbox": "XsuKuW_checkbox",
  "checkmark": "XsuKuW_checkmark",
  "companyImage": "XsuKuW_companyImage",
  "companyImageWrapper": "XsuKuW_companyImageWrapper",
  "companyName": "XsuKuW_companyName",
  "contactInfo": "XsuKuW_contactInfo",
  "content": "XsuKuW_content",
  "customCheckbox": "XsuKuW_customCheckbox",
  "disclaimer": "XsuKuW_disclaimer",
  "downloadInfoImg": "XsuKuW_downloadInfoImg",
  "downloadInfoWrapper": "XsuKuW_downloadInfoWrapper",
  "downloadInformation": "XsuKuW_downloadInformation",
  "downloadTitle": "XsuKuW_downloadTitle",
  "footerStrip": "XsuKuW_footerStrip",
  "formDescription": "XsuKuW_formDescription",
  "formInputs": "XsuKuW_formInputs",
  "formSubtitle": "XsuKuW_formSubtitle",
  "formTitle": "XsuKuW_formTitle",
  "grey": "XsuKuW_grey",
  "header": "XsuKuW_header",
  "hr": "XsuKuW_hr",
  "info": "XsuKuW_info",
  "infoBlock": "XsuKuW_infoBlock",
  "infoBlocks": "XsuKuW_infoBlocks",
  "infoText": "XsuKuW_infoText",
  "infoTitle": "XsuKuW_infoTitle",
  "infoWrapper": "XsuKuW_infoWrapper",
  "isCheckDanger": "XsuKuW_isCheckDanger",
  "isDanger": "XsuKuW_isDanger",
  "label": "XsuKuW_label",
  "medicareCenterWebpageLink": "XsuKuW_medicareCenterWebpageLink",
  "nameContainer": "XsuKuW_nameContainer",
  "notification": "XsuKuW_notification",
  "profileImage": "XsuKuW_profileImage",
  "profileImageAgentName": "XsuKuW_profileImageAgentName",
  "profileImageWrapper": "XsuKuW_profileImageWrapper",
  "socialIcon": "XsuKuW_socialIcon",
  "socials": "XsuKuW_socials",
  "strip": "XsuKuW_strip",
  "text": "XsuKuW_text",
  "title": "XsuKuW_title",
  "uppercase": "XsuKuW_uppercase",
  "white": "XsuKuW_white",
  "wrapper": "XsuKuW_wrapper",
});
